// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Box, Typography } from '@metarouter-private/mr-mui';

export default function FileUploadButton({
  accept,
  onChange,
  helperText,
  buttonText = 'Choose File',
  testId,
  disabled = false,
}) {
  return (
    <Box>
      <Button variant="outlined" component="label" disabled={disabled}>
        {buttonText}
        <input type="file" hidden accept={accept} onChange={onChange} data-test-id={testId} disabled={disabled} />
      </Button>
      {helperText && (
        <Typography variant="caption" display="block" sx={{ mt: 1 }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
}

FileUploadButton.propTypes = {
  accept: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  helperText: PropTypes.string,
  buttonText: PropTypes.string,
  testId: PropTypes.string,
  disabled: PropTypes.bool,
};
